import React from 'react';
import styles from './Loader.less';

const Loader = (/* {  spinning, fullScreen } */) => {
  return (<div className={styles.loader}>
    <div className={styles.wrapper}>
      <div className={styles.inner} />
      <div className={styles.text} >LOADING</div>
    </div>
  </div>);
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js